//
//
//
//
//
//
//
//

import RbDate from '@/utils/rb-date'
import VueCountdown from '@chenfengyuan/vue-countdown'
import qs from 'qs'
import get from 'lodash/get'

export default {
  components: {
    [VueCountdown.name]: VueCountdown,
  },
  props: {
    start: Number,
    end: Number,
    hideIfExpired: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: '%dd:%hh:%mm:%ss',
    },
  },
  data() {
    return {
      isExpired: false,
    }
  },
  computed: {
    showCountdown() {
      const now = this.now
      const isExpired = this.isExpired || now >= this.end
      if (this.hideIfExpired === true && isExpired) {
        return false
      }

      if (this.start > now) {
        return false
      }

      return true
    },
    now() {
      const queryParams = qs.parse(window.location.href)
      const previewDate = get(queryParams, 'previewDate', null)
      if (previewDate) {
        const [date, time, timeZone] = previewDate.split(' ')
        const [day, month, year] = date.split('-')
        const startHours = RbDate.fromZonedTimeDate(`${year}-${month}-${day} ${time}`, timeZone)
        return startHours.getTime()
      } else {
        return Date.now()
      }
    },
    remainingTime() {
      return Math.max(0, this.end - this.now)
    },
  },
  methods: {
    addDecimal(n) {
      return n < 10 ? `0${n}` : n
    },
    formatCountdown(props) {
      const result = this.format
        .replace('%dd', this.addDecimal(props.days))
        .replace('%hh', this.addDecimal(props.hours))
        .replace('%mm', this.addDecimal(props.minutes))
        .replace('%ss', this.addDecimal(props.seconds))
        .replace('%d', props.days)
        .replace('%h', props.hours)
        .replace('%m', props.minutes)
        .replace('%s', props.seconds)
      return props.days < 1 ? result.slice(6) : result
    },
    onEnd() {
      this.isExpired = true
    },
  },
}
